// 缓存
const PREFIX = 'phr_org_'

const formatKey = key => (PREFIX + key).toUpperCase()

// Token 令牌
const AUTH_TOKEN = formatKey('token')
// 用户名
const USER_NAME = formatKey('username')
// 账户
const ACCOUNT = formatKey('account')

export default {
  get token() {
    return JSON.parse(localStorage.getItem(AUTH_TOKEN))
  },
  set token(t) {
    localStorage.setItem(AUTH_TOKEN, JSON.stringify(t))
  },
  get username() {
    return JSON.parse(localStorage.getItem(USER_NAME))
  },
  set username(u) {
    localStorage.setItem(USER_NAME, JSON.stringify(u))
  },
  get account() {
    return JSON.parse(localStorage.getItem(ACCOUNT))
  },
  set account(a) {
    localStorage.setItem(ACCOUNT, JSON.stringify(a))
  },
  // 指定移除
  remove: s => {
    localStorage.removeItem(formatKey(s))
  },
  // 批量移除
  clearKeysByUser: () => {
    // 用户相关 key
    const keys = [AUTH_TOKEN, USER_NAME, ACCOUNT]
    keys.forEach(item => {
      localStorage.removeItem(item)
    })
  },
  // 全部清空
  clear: () => {
    localStorage.clear()
  }
}
